import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ReactionType } from '../types';

@Component({
  selector: 'app-reaction-list',
  templateUrl: './reaction-list.component.html',
  styleUrls: ['./reaction-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReactionListComponent {
  @Input() reactions?: ReactionType[] | null;
  @Output() reactionClicked = new EventEmitter<string>();
}
